import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import JobseekerHeader from './JobseekerHeader';
import JobseekerFooter from './JobseekerFooter';
import { isJobseekerHeaderFooterEnabled } from '../../utils/featureFlags';
import './jobseekerChrome.css';

interface IJobseekerChrome {
  children: ReactNode;
}

// Jobseeker pages live under these path prefixes; recruiter pages (/v1/recruiter)
// and everything else pass through untouched (recruiter keeps its own
// <jt-navbar>/<jt-footer> via Layout).
const isJobseekerPath = (pathname: string): boolean =>
  pathname.startsWith('/v1/interview') || pathname.startsWith('/v2/interview');

/**
 * VI-717: mounts the jobseeker header/footer around the routed content, but only on
 * jobseeker pages and only when the feature flag is on. Wraps <Routes> once (above
 * every per-route maxWidth wrapper) so the header/footer are full-bleed while page
 * content stays centered, and so all jobseeker routes are covered regardless of which
 * new-page sub-flags are active. Transparent pass-through everywhere else.
 */
const JobseekerChrome = ({ children }: IJobseekerChrome) => {
  const { pathname } = useLocation();

  if (!isJobseekerHeaderFooterEnabled() || !isJobseekerPath(pathname)) {
    return <>{children}</>;
  }

  return (
    <div className="jobseeker-chrome">
      <JobseekerHeader />
      <div className="jobseeker-chrome__body">{children}</div>
      <JobseekerFooter />
    </div>
  );
};

export default JobseekerChrome;
